<template>
  <div>
    <div class="home" v-if="!userAgent">
      <!-- banner -->
      <div class="banner">
        <el-carousel :interval="2000" arrow="always">
          <el-carousel-item v-for="(img,index) in bannerImgs" :key="index">
            <img :src="img.image" alt />
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 关于我们 -->
      <div class="about">
        <my-title>
          <p slot="m-title">关于我们</p>
          <p slot="s-title">ABOUT US</p>
        </my-title>
        <div class="h-about f-flex">
          <div class="h-about-left">
            <div>上海赛捷能源科技有限公司</div>
            <div v-html="content"></div>
            <button @click="liaojie">了解更多</button>
          </div>
          <div class="h-about-right">
            <img :src="image2" alt />
          </div>
        </div>
      </div>
      <!-- 产品中心 -->
      <div class="product">
        <my-title>
          <p slot="m-title">产品中心</p>
          <p slot="s-title">PRODUCT</p>
        </my-title>
        <div class="h-product">
          <div @click="proDetails(item.id)" v-for='(item,index) in chanping' :key='index'>
            <img :src="item.image" alt />
            <p style="margin-top: 2.5%;">{{item.title}}</p>
          </div>
        </div>
      </div>
      <!-- more -->
      <div class="more">
        <button @click="product">+ MORE</button>
      </div>
      <!-- 我们的服务 -->
      <div class="serve">
        <my-title>
          <p slot="m-title">我们的服务</p>
          <p slot="s-title">OUR SERVICE</p>
        </my-title>
        <div class="h-serve f-flex">
          <div>
            <img
              :src="isShow1?require('@/assets/images/one.png'):require('@/assets/images/one2.png')"
              @mouseover="mouseover1"
              @mouseout="mouseout1"
              alt
            />
            <p>定制化解决方案</p>
            <p>充分了解用户生产特点及设备运行情况梳理用户用能特点及规律在确保生产及保障的前提下，根据用户端的实际情况制定方案</p>
          </div>
          <div>
            <img
              :src="isShow2?require('@/assets/images/two.png'):require('@/assets/images/two2.png')"
              @mouseover="mouseover2"
              @mouseout="mouseout2"
              alt
            />
            <p>合同能源管理</p>
            <p>以节省的能源费用来支付节能项目全部成本的节能投资方式；这种节能投资方式允许用户使用未来的节能收益为工厂和设备升级，降低目前的运行成本，提高能源的利用效率</p>
          </div>
          <div>
            <img
              :src="isShow3?require('@/assets/images/three.png'):require('@/assets/images/three2.png')"
              @mouseover="mouseover3"
              @mouseout="mouseout3"
              alt
            />
            <p>能源托管</p>
            <p>以最终能源单耗作为与用户的结算依据，理顺动能源运维管理体系，确保生产及保障顺利运行，对托管部分系统及设备进行合理化节能改造，利用公司自有的能源大数据系统提供持续的优化运行方案</p>
          </div>
        </div>
      </div>
      <!-- 案例展示 -->
      <div class="show">
        <my-title>
          <p slot="m-title">案例展示</p>
          <p slot="s-title">CASE</p>
        </my-title>
        <div class="h-show f-flex">
          <div v-for="(item,index) in anli" :key="index">
            <p>{{item.title}}</p>
            <img :src="item.image" alt />
            <p>{{item.simple}}</p>
            <button @click="anliMore(index)">了解更多</button>
          </div>
        </div>
      </div>
      <!-- 新闻动态 -->
      <div class="news">
        <my-title>
          <p slot="m-title">新闻动态</p>
          <p slot="s-title">NEWS</p>
        </my-title>
        <div class="h-news f-flex">
          <div class="h-news-left" v-for="(item,index) in xinwen" :key="index" @click="news">
            <img :src="item.image" alt />
            <p>{{item.title}}</p>
            <p>{{item.simple}}</p>
          </div>
          <div class="h-news-right">
            <div class="f-flex" v-for="(item,index) in xinwen1" :key="index" @click="news">
              <div class="show-num">
                <p>{{item.ctimer}}</p>
                <p>{{item.ctime}}</p>
              </div>
              <div class="show-content">
                <p>{{item.title}}</p>
                <p>{{item.simple}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- more -->
      <div class="more">
        <button @click="newsMore">+ MORE</button>
      </div>
      <!-- 合作伙伴 -->
      <div class="parener">
        <my-title>
          <p slot="m-title">合作伙伴</p>
          <p slot="s-title">OUR&nbsp;PARENER</p>
        </my-title>
        <div class="userImage">
          <vueSeamless :data="userImage" :class-option="optionCustomer" style="width:100%">
            <ul class="userImageAllWrapper">
              <li v-for="(item, index) in userImage" :key="index">
                <img :src="item.image" />
              </li>
            </ul>
          </vueSeamless>
        </div>
      </div>
      <!-- 联系我们 -->
      <div class="contact">
        <my-title>
          <p slot="m-title">联系我们</p>
          <p slot="s-title">COUTACT&nbsp;US</p>
        </my-title>
        <div class="h-content f-flex">
          <div>
            <img src="@/assets/images/dianhua.png" alt />
            <p>{{tel}}</p>
          </div>
          <div>
            <img src="@/assets/images/email.png" alt />
            <p>{{email}}</p>
          </div>
          <div>
            <img src="@/assets/images/pos.png" alt />
            <p>{{address}}</p>
          </div>
        </div>
      </div>
      <div class="scroll" @click="scrollTop" v-show="gotop">
        <img src="@/assets/images/scroll.png" alt />
      </div>
    </div>
    <!-- mobile -->
    <div v-else>
      <!-- 轮播 -->
      <div class="banner1">
        <el-carousel :interval="2000" arrow="always">
          <el-carousel-item v-for="(img,index) in bannerImgs" :key="index">
            <img :src="img.image" alt style="width:100%;height:100%" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 关于我们 -->
      <div class="about1">
        <my-title>
          <p slot="m-title">关于我们</p>
          <p slot="s-title">ABOUT US</p>
        </my-title>
        <div class="h-about1 f-flex1">
          <div class="h-about-left">
            <div>上海赛捷能源科技有限公司</div>
            <div v-html="content"></div>
            <button @click="liaojie">了解更多</button>
          </div>
          <div class="h-about-right">
            <img :src="image2" alt />
          </div>
        </div>
      </div>
      <!-- 产品中心 -->
      <div class="product1">
        <my-title>
          <p slot="m-title">产品中心</p>
          <p slot="s-title">PRODUCT</p>
        </my-title>
        <div class="h-product1">
          <div @click="proDetails(item.id)" v-for='(item,index) in chanping' :key='index'>
            <img :src="item.image" alt />
            <p style="margin-top: 2.5%;">{{item.title}}</p>
          </div>
        </div>
      </div>
      <!-- more -->
      <div class="more1">
        <button @click="product">+ MORE</button>
      </div>
       <!-- 我们的服务 -->
      <div class="serve1">
        <my-title>
          <p slot="m-title">我们的服务</p>
          <p slot="s-title">OUR SERVICE</p>
        </my-title>
        <div class="h-serve1 f-flex">
          <div>
            <img
              :src="isShow1?require('@/assets/images/one.png'):require('@/assets/images/one2.png')"
              @mouseover="mouseover1"
              @mouseout="mouseout1"
              alt
            />
            <p>定制化解决方案</p>
            <div>充分了解用户生产特点及设备运行情况梳理用户用能特点及规律在确保生产及保障的前提下，根据用户端的实际情况制定方案</div>
          </div>
          <div>
            <img
              :src="isShow2?require('@/assets/images/two.png'):require('@/assets/images/two2.png')"
              @mouseover="mouseover2"
              @mouseout="mouseout2"
              alt
            />
            <p>合同能源管理</p>
            <div>以节省的能源费用来支付节能项目全部成本的节能投资方式；这种节能投资方式允许用户使用未来的节能收益为工厂和设备升级，降低目前的运行成本，提高能源的利用效率</div>
          </div>
          <div>
            <img
              :src="isShow3?require('@/assets/images/three.png'):require('@/assets/images/three2.png')"
              @mouseover="mouseover3"
              @mouseout="mouseout3"
              alt
            />
            <p>能源托管</p>
            <div>以最终能源单耗作为与用户的结算依据，理顺动能源运维管理体系，确保生产及保障顺利运行，对托管部分系统及设备进行合理化节能改造，利用公司自有的能源大数据系统提供持续的优化运行方案</div>
          </div>
        </div>
      </div>
       <!-- 案例展示 -->
      <div class="show1">
        <my-title>
          <p slot="m-title">案例展示</p>
          <p slot="s-title">CASE</p>
        </my-title>
        <div class="h-show1 f-flex1">
          <div v-for="(item,index) in anli" :key="index">
            <p>{{item.title}}</p>
            <img :src="item.image" alt />
            <p>{{item.simple}}</p>
            <button @click="anliMore(index)">了解更多</button>
          </div>
        </div>
      </div>
       <!-- 新闻动态 -->
      <div class="news1">
        <my-title>
          <p slot="m-title">新闻动态</p>
          <p slot="s-title">NEWS</p>
        </my-title>
        <div class="h-news1">
          <div class="h-news-left" v-for="(item,index) in xinwen" :key="index" @click="news">
            <img :src="item.image" alt />
            <p>{{item.title}}</p>
            <p>{{item.simple}}</p>
          </div>
          <div class="h-news-right">
            <div class="f-flex" v-for="(item,index) in xinwen1" :key="index" @click="news">
               <div class="show-num">
                <p>{{item.ctimer}}</p>
                <p>{{item.ctime}}</p>
              </div>
              <div class="show-content">
                <p>{{item.title}}</p>
                <p>{{item.simple}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
       <!-- more -->
      <div class="more1">
        <button @click="newsMore">+ MORE</button>
      </div>
       <!-- 合作伙伴 -->
      <div class="parener1">
        <my-title>
          <p slot="m-title">合作伙伴</p>
          <p slot="s-title">OUR&nbsp;PARENER</p>
        </my-title>
        <div class="userImage1">
          <vueSeamless :data="userImage" :class-option="optionCustomer" style="width:100%">
            <ul class="userImageAllWrapper">
              <li v-for="(item, index) in userImage" :key="index">
                <img :src="item.image" />
              </li>
            </ul>
          </vueSeamless>
        </div>
      </div>
       <!-- 联系我们 -->
      <div class="contact1">
        <my-title>
          <p slot="m-title">联系我们</p>
          <p slot="s-title">COUTACT&nbsp;US</p>
        </my-title>
        <div class="h-content1 f-flex">
          <div>
            <img src="@/assets/images/dianhua.png" alt />
            <p>{{tel}}</p>
          </div>
          <div>
            <img src="@/assets/images/email.png" alt />
            <p>{{email}}</p>
          </div>
          <div>
            <img src="@/assets/images/pos.png" alt />
            <p>{{address}}</p>
          </div>
        </div>
      </div>
      <div class="scroll1" @click="scrollTop" v-show="gotop">
        <img src="@/assets/images/scroll.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
import title from "./components/title";
import vueSeamless from "vue-seamless-scroll";
export default {
  name: "Home",
  data() {
    return {
      activeIndex: "/",
      content: "",
      title: "",
      image: "",
      image2: "",
      chanping:[],
      id:'',
      title3: "",
      image3: "",
      anli: [],
      isShow1: false,
      isShow2: false,
      isShow3: false,
      gotop: true,
      bannerImgs: [],
      optionCustomer: {
        step: 1,
        limitMoveNum: 5,
        waitTime: 1,
        direction: 2,
        singleWidth: 30,
        overStop: false,
        openWatch: true,
        singleHeight: 0,
      },
      userImage: [],
      xinwen: [],
      xinwen1: [],
      address: "",
      tel: "",
      email: "",
    };
  },
  components: {
    "my-title": title,
    vueSeamless,
  },
  mounted() {
    var that = this;
    window.addEventListener("scroll", that.handleScroll, true);
    that.$http.get("images/index").then(function (res) { //轮播
      that.bannerImgs = res.data.data;
    });
    that.$http.get("about/home").then(function (res) {
      //关于我们
      that.content = res.data.data.content;
      that.image2 = res.data.data.image;
    });
    that.$http.get("center/home").then(function (res) {//产品中心
      that.chanping = res.data.data
      that.id = res.data.data.id
    });
    that.$http.get("cases/home").then(function (res) {
      // 案例展示
      that.anli = res.data.data;
    });
    that.$http.get("images/part").then(function (res) {
      //合作伙伴
      that.userImage = res.data.data;
    });
    that.$http.get("news/left").then(function (res) {
      //新闻动态
      that.xinwen = res.data.data;
    });
    that.$http.get("news/home").then(function (res) {
      //新闻动态
      that.xinwen1 = res.data.data;
    });
    that.$http.get("contact/index").then(function (res) {
      //联系我们
      that.address = res.data.data.address;
      that.email = res.data.data.email;
      that.tel = res.data.data.tel;
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    changeActiveIndex: function (key) {
      console.log(key);
      this.$router.push(key);
    },
    handleScroll() {
      let scrolltop =
        document.documentElement.scrollTop || document.body.scrollTop;
      scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
    },
    scrollTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    mouseover1() {
      this.isShow1 = true;
    },
    mouseout1() {
      this.isShow1 = false;
    },
    mouseover2() {
      this.isShow2 = true;
    },
    mouseout2() {
      this.isShow2 = false;
    },
    mouseover3() {
      this.isShow3 = true;
    },
    mouseout3() {
      this.isShow3 = false;
    },
    // 产品中心页面跳转
    proDetails(id) {
      this.$router.push(`/proDetails?id=${id}`);
    },
    // 新闻动态
    news() {
      this.$router.push("/news?d=0");
    },
    // more
    product() {
      this.$router.push("/product");
    },
    // news
    newsMore() {
      this.$router.push("/News?d=0");
    },
    // 了解更多
    liaojie() {
      this.$router.push("/about?a=0");
    },
    // anli展示
    anliMore(id) {
      this.$router.push("/show?c=" + id);
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scope>
.banner {
  width: 100%;
  margin-top: 1%;
  img {
    width: 100%;
    height: 100%;
  }
}
.h-about {
  width: 100%;
  background-color: #f5f5f5;
  justify-content: center;
  padding: 3% 0;
  align-items: center;
  .h-about-left {
    width: 40%;
    div:first-child{
      color: #43ae82;
      font-size: 2rem;
      font-weight: 800;
    }
    div:nth-child(2){
       line-height: 1.5rem;
       font-size:16px;
      //  color:#666;
       padding-right: 2rem;
       margin-top: 1rem;
       p{
          margin-top:1.6rem;
          text-align: justify;
          text-overflow:ellipsis;
          overflow:hidden;
          display:-webkit-box;
          -webkit-box-orient:vertical;
          -webkit-line-clamp:5; /*后面的5是设置显示几行*/
          margin: 0 auto;
       }
    }
    button {
      border: 1px solid #43ae82;
      color: #43ae82;
      font-weight: bold;
      font-size: 14px;
      outline: none;
      width: 95px;
      height: 35px;
      border-radius: 3px;
      background-color: #f5f5f5;
      // margin-top: 1rem;
      cursor: pointer;
    }
  }
  .h-about-right {
    width: 40%;
    img {
      width: 100%;
    }
  }
}
.h-product {
  width: 80%;
  margin: 0 auto;
  font-weight: bolder;
  font-size: 1rem;
  text-align: center;
  display: flex;
  margin-top: 1rem;
  justify-content: space-between;
  div {
    width: 45%;
    justify-content: center;
    cursor: pointer;
    img {
      width: 100%;
    }
    p {
      margin: 5%;
    }
  }
}
.more {
  margin: 0 auto;
  width: 80%;
  text-align: center;
  padding-bottom: 4rem;
  button {
    width: 130px;
    height: 42px;
    border: 1px solid #ddd;
    font-size: 14px;
    color: #333;
    border-radius: 4px;
    background: #fff;
    outline: none;
  }
}
.more button:hover {
  border-color: #43ae82;
  color: #43ae82;
  cursor: pointer;
}
.serve {
  background: url("../../assets/images/bg.png");
  color: white;
  padding: 2% 0;
  .s-title {
    color: white;
  }
  .h-serve {
    justify-content: center;
    width: 80%;
    margin: 0 auto;
    div {
      width: 33%;
      text-align: center;
      img {
        width: 40%;
        margin: 4%;
        border-radius: 50%;
        cursor: pointer;
      }
      p:nth-of-type(1) {
        margin: 4% 0;
        font-size: 20px;
      }
      p:nth-of-type(2) {
        font-size: 14px;
        width: 60%;
        margin: 0 auto;
        line-height: 1.5rem;
      }
    }
  }
}
.show {
  background-color: #f5f5f5;
  padding-bottom: 4rem;
  .h-show {
    width: 80%;
    margin: 0 auto;
    display: flex;
    div {
      width: 31%;
      background: #ffffff;
      margin-right:3%;
      box-shadow: 2px 4px 5px 0px rgba(0, 0, 0, 0.15);
      img {
        width: 93%;
        padding-top: 1rem;
        padding-left: 1rem;
      }
      p:nth-of-type(1) {
        color: #43ae82;
        font-weight: bold;
        font-size: 20px;
        padding-top: 2rem;
        padding-left: 1rem;
      }
      p:nth-of-type(2) {
        font-size: 14px;
        width: 94%;
        line-height: 1.4rem;
        padding-left: 1rem;
      }
      button {
        margin: 5% 0;
        color: #43ae82;
        border: 1px solid #43ae82;
        background: white;
        font-weight: 0.5rem;
        padding: 1% 3%;
        border-radius: 4px;
        font-size: 14px;
        min-width: 95px;
        height: 35px;
        outline: none;
        margin-left: 1rem;
        margin-top: 2rem;
        margin-bottom: 2rem;
      }
    }
    :hover {
      background: #43ae82;
      color: white;
      cursor: pointer;
      p:nth-of-type(1) {
        color: white;
      }
      button {
        background: #43ae82;
        color: white;
        border-color: white;
      }
    }
  }
}
.news {
  width: 80%;
  margin: 0 auto;
  .h-news {
    justify-content: center;
    margin-top: 2%;
  }
  .h-news-left {
    width: 40%;
    font-size: 0.7rem;
    margin-right: 5%;
    line-height: 1.25rem;
    cursor: pointer;
    img {
      width: 100%;
    }
    p:nth-of-type(1) {
      font-weight: bold;
      margin: 1% 0;
      font-size: 1rem;
    }
    p:nth-of-type(2) {
      line-height: 1.6rem;
    }
  }
  .h-news-right {
    width: 60%;
    > div {
      border-bottom: 1px solid #eeeeee;
      border-top: none;
      padding: 0 3% 3% 2%;
      margin-bottom: 7%;
    }
    .show-num {
      width: 20%;
      min-width: 65px;
      max-width: 100px;
      border: 1px solid #43ae82;
      text-align: center;
      color: #43ae82;
      margin-right: 3%;
      border-radius: 5px;
      p:nth-of-type(1) {
        font-size: 35px;
        font-weight: bold;
        margin: 8% 0;
      }
      p:nth-of-type(2) {
        font-size: 14px;
      }
    }
    .show-content {
      p:nth-of-type(1) {
        font-weight: bold;
        margin: 0 0 2% 0;
        font-size: 18px;
      }
      p:nth-child(2) {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 1.6rem;
      }
    }
  }
}
.news .h-news-right .show-content:hover {
  color: #43ae82;
  cursor: pointer;
}
.parener {
  width: 100%;
  margin: 0 auto;
  background: url("../../assets/images/ind_case_bg.png");
  padding-bottom: 5%;
  .h-par {
    width: 80%;
    overflow-x: auto;
    overflow-y: hidden;
    margin: 0 auto;
    > div {
      display: grid;
      grid-template-columns: repeat(5, 20%);
      gap: 30px;
    }
    img {
      width: 100%;
      padding-bottom: 10px;
    }
  }
}
.h-content {
  width: 80%;
  margin: 0 auto;
  justify-content: space-between;
  padding-bottom: 5%;
  > div {
    width: 30%;
    border: 1px solid #43ae82;
    padding: 1% 0;
    text-align: center;
    position: relative;
    img {
      position: absolute;
      top: -20px;
      left: 50%;
      transform: translateX(-50%);
    }
    p {
      margin-top: 1.875rem;
      font-size: 0.875rem;
      color: #333;
      font-weight: bold;
    }
  }
}
.scroll {
  position: fixed;
  bottom: 5rem;
  right: 3rem;
  cursor: pointer;
}
.userImage {
  overflow: hidden;
  display: flex;
  width: 80%;
  margin: 0 auto;
  height: 100%;
  .userImageAllWrapper {
    list-style: none;
    display: flex;
    li {
      padding-right:1rem;
      img {
        width: 232px;
        display: flex;
        cursor: pointer;
        border:1px solid #ddd;
      }
    }
  }
}
// mobile
.banner1 {
  width: 100%;
  height: 100%;
}
.about1 {
  .m-title {
    margin-top: 0.2rem;
    font-size: 0.9rem !important;
  }
  .s-title{
    font-size: 0.7rem !important;
  }
}
.h-about1 {
  width: 100%;
  background-color: #f5f5f5;
  justify-content: center;
  padding: 3% 0;
  align-items: center;
  .h-about-left {
    width: 90%;
    margin:0 auto;
    div:first-child{
      color:#43ae82;
      font-size:0.9rem;
      font-weight:bold;
    }
    div:nth-child(2){
      color:#666;
      font-size:0.7rem;
      line-height: 1.2rem;
      p{
        margin-top:0.5rem;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp:6;
        -webkit-box-orient: vertical;
      }
    }
    button {
      border: 1px solid #43ae82;
      color: #43ae82;
      font-weight: bold;
      font-size: 12px;
      outline: none;
      width:85px;
      height: 25px;
      border-radius: 3px;
      background-color: #f5f5f5;
    }
  }
  .h-about-right {
    width: 90%;
    margin:0 auto;
    margin-top: 0.5rem;
    img {
      width: 100%;
    }
  }
}
.product1{
  .line1{
    width:20% !important;
  }
  .m-title{
    font-size: 0.9rem !important;
    margin-top: 0.2rem;
  }
}
.h-product1 {
  width: 90%;
  margin: 0 auto;
  font-weight: bolder;
  font-size: 1rem;
  text-align: center;
  display: flex;
  margin-top: 1rem;
  justify-content: space-between;
  div {
    width: 45%;
    justify-content: center;
    cursor: pointer;
    img {
      width: 100%;
    }
    p {
      margin: 5%;
      font-size:11px;
    }
  }
}
.more1 {
  margin: 0 auto;
  width: 80%;
  text-align: center;
  padding-bottom: 1rem;
  margin-top: 0.5rem;
  button {
    width: 100px;
    height: 25px;
    border: 1px solid #ddd;
    font-size: 12px;
    color: #333;
    border-radius: 4px;
    background: #fff;
    outline: none;
  }
}
.serve1 {
  background: url("../../assets/images/bg.png");
  color: white;
  padding: 2% 0;
  width:100%;
  height:100%;
  padding-bottom: 1rem;
  .m-title {
    color: white;
    font-size: 0.9rem !important;
  }
  .h-serve1 {
    justify-content: center;
    width: 90%;
    margin: 0 auto;
    justify-content: space-between;
    div {
      width: 33%;
      text-align: center;
      img {
        width: 70%;
        margin: 4%;
        border-radius: 50%;
        cursor: pointer;
      }
      p:nth-of-type(1) {
        margin: 4% 0;
        font-size: 13px;
      }
     div{
        font-size: 10px;
        line-height: 1rem;
        text-overflow:ellipsis;
        overflow:hidden;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:3; /*后面的3是设置显示几行*/
        width: 90%;
        margin: 0 auto;
        margin-top: 0.5rem;
      }
    }
  }
}
.show1 {
  background-color: #f5f5f5;
  padding-bottom: 1rem;
  .m-title{
    font-size: 0.9rem !important;
    margin-top: 0.2rem;
  }
  .h-show1{
    width: 90%;
    justify-content: space-between;
    margin: 0 auto;
    div {
      background: #ffffff;
      box-shadow: 2px 4px 5px 0px rgba(0, 0, 0, 0.15);
      margin-top:1rem;
      img {
        width: 93%;
        padding-top: 1rem;
        padding-left: 0.5rem;
      }
      p:nth-of-type(1) {
        color: #43ae82;
        font-weight: bold;
        font-size: 1rem;
        padding-top: 1rem;
        padding-left: 0.5rem;
      }
      p:nth-of-type(2) {
        font-size: 11px;
        width: 94%;
        line-height: 1.4rem;
        padding-left: 0.5rem;
      }
      button {
        margin: 5% 0;
        color: #43ae82;
        border: 1px solid #43ae82;
        background: white;
        font-weight: 0.5rem;
        padding: 1% 3%;
        border-radius: 4px;
        font-size: 12px;
        min-width: 85px;
        height: 25px;
        outline: none;
        margin-left: 0.5rem;
        margin-top: 1rem;
        margin-bottom: 1rem;
      }
    }
    :hover {
      background: #43ae82;
      color: white;
      font-size: 0.9rem;
      cursor: pointer;
      p:nth-of-type(1) {
        color: white;
      }
      button {
        background: #43ae82;
        color: white;
        border-color: white;
      }
    }
  }
}
.news1 {
  width: 90%;
  margin: 0 auto;
  .m-title{
    font-size: 0.9rem !important;
    margin-top: 0.2rem;
  }
  .h-news1 {
    justify-content: center;
    margin-top: 2%;
  }
  .h-news-left {
    width:100%;
    font-size: 0.7rem;
    margin-right: 5%;
    line-height: 1.25rem;
    img {
      width: 100%;
    }
    p:nth-of-type(1) {
      font-weight: bold;
      margin: 1% 0;
      font-size: 0.8rem;
    }
    p:nth-of-type(2) {
      line-height: 1.6rem;
      font-size: 11px;
      text-overflow:ellipsis;
      overflow:hidden;
      display:-webkit-box;
      -webkit-box-orient:vertical;
      -webkit-line-clamp:3; /*后面的3是设置显示几行*/
      margin: 0 auto;
      margin-top: 0.5rem;
    }
  }
  .h-news-right {
    width: 100%;
    margin-top: 0.5rem;
    > div {
      border-bottom: 1px solid #eeeeee;
      border-top: none;
      padding: 0 3% 3% 1%;
      margin-bottom: 7%;
    }
    .show-num {
      width: 20%;
      min-width: 65px;
      max-width: 100px;
      border: 1px solid #43ae82;
      text-align: center;
      color: #43ae82;
      margin-right: 3%;
      border-radius: 5px;
      p:nth-of-type(1) {
        font-size: 20px;
        font-weight: bold;
        margin: 8% 0;
      }
      p:nth-of-type(2) {
        font-size: 13px;
      }
    }
    .show-content {
      p:nth-of-type(1) {
        font-weight: bold;
        margin: 0 0 2% 0;
        font-size: 12px;
      }
      p:nth-child(2) {
        font-size: 10px;
        color: rgba(51, 51, 51, 1);
        line-height: 1.2rem;
        text-overflow:ellipsis;
        overflow:hidden;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2; /*后面的3是设置显示几行*/
        margin: 0 auto;
        margin-top: 0.5rem;
      }
    }
  }
}
.parener1 {
  width: 100%;
  margin: 0 auto;
  background: url("../../assets/images/ind_case_bg.png");
  padding-bottom: 5%;
  .m-title{
    font-size: 0.9rem !important;
  }
  .h-par {
    width: 90%;
    overflow-x: auto;
    overflow-y: hidden;
    margin: 0 auto;
    > div {
      display: grid;
      grid-template-columns: repeat(5, 20%);
      gap: 30px;
    }
    img {
      width: 100%;
      padding-bottom: 10px;
    }
  }
}
.userImage1 {
  overflow: hidden;
  display: flex;
  width: 90%;
  margin: 0 auto;
  height: 100%;
  .userImageAllWrapper {
    list-style: none;
    display: flex;
    li {
      padding-right:1rem;
      img {
        width: 232px;
        display: flex;
        cursor: pointer;
        border:1px solid #ddd;
        
      }
    }
  }
}
.contact1{
   .m-title{
    font-size: 0.9rem !important;
    margin-top: 0.2rem;
  }
}
.h-content1 {
  width: 90%;
  margin: 0 auto;
  justify-content: space-between;
  padding-bottom: 5%;
  margin-top: 1.5rem;
  > div {
    width: 32%;
    border: 1px solid #43ae82;
    padding: 1% 0;
    text-align: center;
    position: relative;
    padding-top: 1.2rem;
    img {
      position: absolute;
      top: -20px;
      left: 50%;
      transform: translateX(-50%);
      width: 2.2rem;
    }
    p {
      // margin-top: 1rem;
      font-size: 10px;
      color: #333;
      font-weight: bold;
      word-wrap:break-word;
      width:90%;
      margin:0 auto;
      // line-height:rem;
    }
  }
}
.scroll1 {
    position: fixed;
    bottom: 8rem;
    right: 1rem;
    width: 2rem;
    height: 2rem;
  img{
    width: 100%;
    height: 100%;
  }
}
</style>
<style lang="scss">
.el-carousel__container {
  height: 600px !important;
}
.banner1 .el-carousel__container {
  position: relative;
  height: 150px !important;
}
</style>